/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './search-filter.component';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from './utils.service';
import * as import9 from '@angular/router/src/router';
import * as import10 from '@angular/router/src/router_state';
import * as import11 from './search-elasticsearch.service';
import * as import12 from '@angular/core/src/metadata/view';
import * as import13 from '@angular/core/src/linker/component_factory';
import * as import14 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import15 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import16 from './map-to-iterable.pipe';
import * as import17 from './name-resolver.pipe';
import * as import18 from '@angular/core/src/linker/template_ref';
import * as import19 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import20 from '@angular/common/src/directives/ng_if';
import * as import21 from '@angular/common/src/directives/ng_for';
export class Wrapper_SearchFilterComponent {
  context:import0.SearchFilterComponent;
  changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  constructor(p0:any,p1:any,p2:any,p3:any) {
    this.changed = false;
    this.context = new import0.SearchFilterComponent(p0,p1,p2,p3);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
  }
  check_esQuery(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.esQuery = currValue;
      this._expr_0 = currValue;
    }
  }
  check_esFilters(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this.changed = true;
      this.context.esFilters = currValue;
      this._expr_1 = currValue;
    }
  }
  check_title(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this.changed = true;
      this.context.title = currValue;
      this._expr_2 = currValue;
    }
  }
  check_target(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this.changed = true;
      this.context.target = currValue;
      this._expr_3 = currValue;
    }
  }
  check_labels(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this.changed = true;
      this.context.labels = currValue;
      this._expr_4 = currValue;
    }
  }
  check_language(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this.changed = true;
      this.context.language = currValue;
      this._expr_5 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_SearchFilterComponent_Host:import4.RenderComponentType = (null as any);
class _View_SearchFilterComponent_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _SearchFilterComponent_0_4:Wrapper_SearchFilterComponent;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFilterComponent_Host0,renderType_SearchFilterComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'search-filters',import2.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_SearchFilterComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._SearchFilterComponent_0_4 = new Wrapper_SearchFilterComponent(this.parentInjector.get(import8.UtilsService),this.parentInjector.get(import9.Router),this.parentInjector.get(import10.ActivatedRoute),this.parentInjector.get(import11.ElasticSearchService));
    this._appEl_0.initComponent(this._SearchFilterComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._SearchFilterComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.SearchFilterComponent) && (0 === requestNodeIndex))) { return this._SearchFilterComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SearchFilterComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._SearchFilterComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchFilterComponent_Host0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_SearchFilterComponent_Host === (null as any))) { (renderType_SearchFilterComponent_Host = viewUtils.createRenderComponentType('',0,import12.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_SearchFilterComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const SearchFilterComponentNgFactory:import13.ComponentFactory<import0.SearchFilterComponent> = new import13.ComponentFactory<import0.SearchFilterComponent>('search-filters',viewFactory_SearchFilterComponent_Host0,import0.SearchFilterComponent);
const styles_SearchFilterComponent:any[] = ([] as any[]);
var renderType_SearchFilterComponent:import4.RenderComponentType = (null as any);
class _View_SearchFilterComponent0 extends import3.AppView<import0.SearchFilterComponent> {
  _text_0:any;
  _el_1:any;
  _text_2:any;
  _anchor_3:any;
  /*private*/ _appEl_3:import5.AppElement;
  _TemplateRef_3_5:any;
  _NgIf_3_6:import14.Wrapper_NgIf;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _appEl_5:import5.AppElement;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import14.Wrapper_NgIf;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _appEl_7:import5.AppElement;
  _TemplateRef_7_5:any;
  _NgFor_7_6:import15.Wrapper_NgFor;
  _text_8:any;
  _pipe_mapToIterable_0:import16.MapToIterable;
  _pipe_nameResolver_1:import17.NameResolverPipe;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFilterComponent0,renderType_SearchFilterComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'\n    ',(null as any));
    this._el_1 = import2.createRenderElement(this.renderer,parentRenderNode,'p',new import2.InlineArray2(2,'class','font-alt text-uppercase'),(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'\n      ',(null as any));
    this._anchor_3 = this.renderer.createTemplateAnchor(this._el_1,(null as any));
    this._appEl_3 = new import5.AppElement(3,1,this,this._anchor_3);
    this._TemplateRef_3_5 = new import18.TemplateRef_(this._appEl_3,viewFactory_SearchFilterComponent1);
    this._NgIf_3_6 = new import14.Wrapper_NgIf(this._appEl_3.vcRef,this._TemplateRef_3_5);
    this._text_4 = this.renderer.createText(this._el_1,'\n          ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_1,(null as any));
    this._appEl_5 = new import5.AppElement(5,1,this,this._anchor_5);
    this._TemplateRef_5_5 = new import18.TemplateRef_(this._appEl_5,viewFactory_SearchFilterComponent2);
    this._NgIf_5_6 = new import14.Wrapper_NgIf(this._appEl_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_1,'\n      ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_1,(null as any));
    this._appEl_7 = new import5.AppElement(7,1,this,this._anchor_7);
    this._TemplateRef_7_5 = new import18.TemplateRef_(this._appEl_7,viewFactory_SearchFilterComponent3);
    this._NgFor_7_6 = new import15.Wrapper_NgFor(this._appEl_7.vcRef,this._TemplateRef_7_5,this.parentInjector.get(import19.IterableDiffers),this.ref);
    this._text_8 = this.renderer.createText(this._el_1,'\n    ',(null as any));
    this._pipe_mapToIterable_0 = new import16.MapToIterable();
    this._pipe_nameResolver_1 = new import17.NameResolverPipe();
    this.init(([] as any[]),[
      this._text_0,
      this._el_1,
      this._text_2,
      this._anchor_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._anchor_7,
      this._text_8
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.TemplateRef) && (3 === requestNodeIndex))) { return this._TemplateRef_3_5; }
    if (((token === import20.NgIf) && (3 === requestNodeIndex))) { return this._NgIf_3_6.context; }
    if (((token === import18.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import20.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    if (((token === import18.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import21.NgFor) && (7 === requestNodeIndex))) { return this._NgFor_7_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_3_0_0:any = ((this.context.esFilters.length > 1) || (this.context.searchQueryParams != (null as any)));
    this._NgIf_3_6.check_ngIf(currVal_3_0_0,throwOnChange,false);
    this._NgIf_3_6.detectChangesInInputProps(this,this._anchor_3,throwOnChange);
    const currVal_5_0_0:any = (this.context.searchQueryParams != (null as any));
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.detectChangesInInputProps(this,this._anchor_5,throwOnChange);
    const currVal_7_0_0:any = this.context.esFilters;
    this._NgFor_7_6.check_ngForOf(currVal_7_0_0,throwOnChange,false);
    this._NgFor_7_6.detectChangesInInputProps(this,this._anchor_7,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_SearchFilterComponent0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<import0.SearchFilterComponent> {
  if ((renderType_SearchFilterComponent === (null as any))) { (renderType_SearchFilterComponent = viewUtils.createRenderComponentType('',0,import12.ViewEncapsulation.None,styles_SearchFilterComponent,{})); }
  return new _View_SearchFilterComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_SearchFilterComponent1 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFilterComponent1,renderType_SearchFilterComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'span',new import2.InlineArray2(2,'class','search-filters-intro letter-spacing-4 font-weight-600'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_2:any = import2.interpolate(1,'\n          ',this.parent.context.title,': ');
    if (import2.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchFilterComponent1(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchFilterComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_SearchFilterComponent2 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFilterComponent2,renderType_SearchFilterComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_8 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'span',new import2.InlineArray2(2,'title','search'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,' \n            ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'a',new import2.InlineArray4(4,'class','pointer letter-spacing-3 search-filter','title','search'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._el_4 = import2.createRenderElement(this.renderer,this._el_2,'small',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'x',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n      ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'click',this.eventHandler(this._handle_click_2_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_8:any = import2.interpolate(1,'\n              "',this.parent.context.esQuery.query.bool.must.multi_match.query,'" ');
    if (import2.checkBinding(throwOnChange,this._expr_8,currVal_8)) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.context.onRemoveSearch()) !== false);
    return (true && pd_2_0);
  }
}
function viewFactory_SearchFilterComponent2(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchFilterComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_SearchFilterComponent3 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _appEl_2:import5.AppElement;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import15.Wrapper_NgFor;
  _text_3:any;
  _pipe_mapToIterable_0_0:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFilterComponent3,renderType_SearchFilterComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'span',new import2.InlineArray2(2,'title','filter'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_2 = new import5.AppElement(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import18.TemplateRef_(this._appEl_2,viewFactory_SearchFilterComponent4);
    this._NgFor_2_6 = new import15.Wrapper_NgFor(this._appEl_2.vcRef,this._TemplateRef_2_5,this.parent.parentInjector.get(import19.IterableDiffers),this.parent.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n      ',(null as any));
    this._pipe_mapToIterable_0_0 = import2.pureProxy1((<_View_SearchFilterComponent0>this.parent)._pipe_mapToIterable_0.transform.bind((<_View_SearchFilterComponent0>this.parent)._pipe_mapToIterable_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import21.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2_0_0:any = valUnwrapper.unwrap(import2.castByValue(this._pipe_mapToIterable_0_0,(<_View_SearchFilterComponent0>this.parent)._pipe_mapToIterable_0.transform)(this.context.$implicit.term));
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,valUnwrapper.hasWrappedValue);
    this._NgFor_2_6.detectChangesInInputProps(this,this._anchor_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchFilterComponent3(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchFilterComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_SearchFilterComponent4 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _appEl_2:import5.AppElement;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import14.Wrapper_NgIf;
  _text_3:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFilterComponent4,renderType_SearchFilterComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'a',new import2.InlineArray2(2,'class','pointer letter-spacing-3 search-filter'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_2 = new import5.AppElement(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import18.TemplateRef_(this._appEl_2,viewFactory_SearchFilterComponent5);
    this._NgIf_2_6 = new import14.Wrapper_NgIf(this._appEl_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import20.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = (this.context.$implicit.key != 'active');
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.detectChangesInInputProps(this,this._anchor_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.parent.context.onRemoveFilter(this.context.$implicit.key,this.context.$implicit.value)) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_SearchFilterComponent4(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchFilterComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_SearchFilterComponent5 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_nameResolver_1_0:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchFilterComponent5,renderType_SearchFilterComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'span',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_nameResolver_1_0 = import2.pureProxy1((<_View_SearchFilterComponent0>this.parent.parent.parent)._pipe_nameResolver_1.transform.bind((<_View_SearchFilterComponent0>this.parent.parent.parent)._pipe_nameResolver_1));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_2:any = import2.interpolate(1,'\n            ',((this.parent.parent.parent.context.labels && this.parent.parent.parent.context.labels[this.parent.context.$implicit.key.replace('.raw','')].VALUES)? this.parent.parent.parent.context.labels[this.parent.context.$implicit.key.replace('.raw','')].VALUES[this.parent.context.$implicit.value][this.parent.parent.parent.context.language]: valUnwrapper.unwrap(import2.castByValue(this._pipe_nameResolver_1_0,(<_View_SearchFilterComponent0>this.parent.parent.parent)._pipe_nameResolver_1.transform)(this.parent.context.$implicit.value))),' ×');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchFilterComponent5(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchFilterComponent5(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/search-filter.component.ngfactory.ts